import * as React from 'react';
import { memo } from 'react';
import { DropdownItem } from 'reactstrap';
import upgradeSvg from '../../dist/assets/images/upgrade-icon.svg';
import { Tooltip } from './Tooltip';
export var PaidOption = memo(function (_a) {
    var isUnlocked = _a.isUnlocked, className = _a.className, children = _a.children, onLocked = _a.onLocked, onAllowed = _a.onAllowed, _b = _a.tooltip, tooltip = _b === void 0 ? 'This feature included in all upgraded plans' : _b;
    var menuItem = (React.createElement(DropdownItem, { className: className, onClick: isUnlocked ? onAllowed : onLocked },
        children,
        !isUnlocked && React.createElement("img", { src: upgradeSvg, style: { position: 'relative', left: 10 } })));
    return isUnlocked ? (menuItem) : (React.createElement(Tooltip, { placement: "left", modifiers: {
            preventOverflow: {
                enabled: true,
                boundariesElement: 'viewport',
            },
        }, flip: true, target: "", trigger: React.createElement("div", null, menuItem) }, tooltip));
});
//# sourceMappingURL=PaidOption.js.map